/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Autocomplete,
  Box,
  Grid,
  MenuItem,
  Stack,
  TextField,
} from '@mui/material';
import {
  Option,
  ChipOption,
  CountryOption,
  ChipSelectList,
} from '@marageti/z4-lib';
import { TripRequestStatus } from '@marageti/z4-sdk/lib/travel';

export const statusChips: ChipOption[] = [
  { key: 0, label: 'Unverified', value: TripRequestStatus.PendingStatus },
  { key: 1, label: 'Unmatched', value: TripRequestStatus.VerifiedStatus },
];

type IncomingFiltersProps = {
  destinationOptions: CountryOption[];
  isLoadingDestinations: boolean;
  onDestinationChange: (event: React.SyntheticEvent, countries: CountryOption[]) => void;
  selectedDestinations: CountryOption[];
  onSortChange: (v: string) => void;
  sortBy: string;
  sortByOptions: Option[];
  onTagChange: (selectedTags: string) => void;
  selectedTag: string;
  tagOptions: ChipOption[];
  selectedStatusChips: string[];
  onStatusChipChange: (selectedChips: string[]) => void;
};

const IncomingFilters = ({
  // Destination Props
  destinationOptions,
  isLoadingDestinations,
  onDestinationChange,
  selectedDestinations,
  // Sort Props
  onSortChange,
  sortBy,
  sortByOptions,
  // Tag Props
  onTagChange,
  selectedTag,
  tagOptions,
  selectedStatusChips,
  onStatusChipChange,
}: IncomingFiltersProps) => (
  <Box sx={{ mb: 4 }}>
    <Grid
      container
      columnSpacing={2}
    >
      <Grid item mobile={12} desktop={2.8}>
        <TextField
          fullWidth
          key="tags-select"
          label="Tags"
          name="tag"
          onChange={(e) => onTagChange(e.target.value)}
          select
          value={selectedTag}
        >
          {tagOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item mobile={12} desktop={2.8}>
        <Autocomplete
          id="primaryDestination"
          isOptionEqualToValue={(o, v) => o.value === v.value}
          loading={isLoadingDestinations}
          onChange={onDestinationChange}
          options={destinationOptions}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Destinations"
              name="primaryDestination"
            />
          )}
          ChipProps={{
            size: 'small',
            sx: {
              backgroundColor: 'secondary.light',
            },
          }}
          fullWidth
          multiple
          value={selectedDestinations}
        />
      </Grid>

      <Grid item mobile={12} desktop={2.8}>
        <TextField
          fullWidth
          key="sort-by-select"
          label="Sort By"
          name="sortBy"
          onChange={(e) => onSortChange(e.target.value)}
          select
          value={sortBy}
        >
          {sortByOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.title}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
    <Stack direction={{ mobile: 'column', desktop: 'row' }} spacing={2}>
      <ChipSelectList
        label="Status"
        chipOptions={statusChips}
        selectedChips={selectedStatusChips}
        onChange={onStatusChipChange}
      />
    </Stack>
  </Box>
);
export default IncomingFilters;
